import {UserActions} from '@nw/ui-core-shared/store/actions';
import {Action} from '@ngrx/store';
import {AppPrincipal, AppPrincipalStatus} from '@nw/ui-core-shared/services/app-principal';


export const INITIAL_USER_STATE = AppPrincipal.createGuest();

export function appPrincipalReducer(state: AppPrincipal = INITIAL_USER_STATE, action: Action): AppPrincipal {

  switch (action.type)  {

    case UserActions.SET_CURRENT_USER:
      return handleSetCurrentUserAction(state, action);

    case UserActions.LOGIN_FAIL:
      return new AppPrincipal(state.getUserId(), AppPrincipalStatus.AUTHENTICATION_FAILED);

    default:
      return state;

  }

}

function handleSetCurrentUserAction(state: AppPrincipal, action: Action) {
  return action.payload;
}




// WEBPACK FOOTER //
// ./src/main/angular/app/main-state/reducers/user.reducer.ts